module.exports = __webpack_public_path__ + "img/decosummit.327eef10.svg";